module.exports = __webpack_public_path__ + "img/print_heartprint.44aaace.jpg";